<template>
  <div>
    <div class="mt-3 mb-5 underline">
      <span class=" page-title">1 약관동의</span>
      <mdb-icon  icon="chevron-right" class="mx-4" />
      2 본인 인증
      <mdb-icon  icon="chevron-right" class="mx-4" />
      3 회원 정보
      <mdb-icon  icon="chevron-right" class="mx-4" />
      4 가입 완료
    </div>
    <div class="title bolder">NCS평가관리시스템 이용약관(필수)</div>
    <div v-html="$linebreak(agreement1)" class="border my-3" style="font-size:15px; height:350px; overflow-x:hidden; overflow-y:auto;"></div>
    <label class="my-2">
      <input type="checkbox"  v-model="agreements[0]">
      본인은 이용약관을 확인하였고 이에 동의합니다.
    </label>

    <div class="title bolder my-3">개인정보 수집 및 이용내역(필수)</div>
    <div v-html="$linebreak(agreement2)" class="border" style="font-size:15px; height:260px; overflow-x:hidden; overflow-y:auto;"></div>
    <label class="my-2">
      <input type="checkbox"  v-model="agreements[1]">
      본인은 이용약관을 확인하였고 이에 동의합니다.
    </label>

    <div class="title bolder my-3">선택적 개인정보 수집 및 이용내역(동의거부 가능)</div>
    <div v-html="$linebreak(agreement3)" class="border" style="font-size:15px; height:300px; overflow-x:hidden; overflow-y:auto;"></div>
    <label class="my-2">
      <input type="checkbox"  v-model="agreements[2]">
      본인은 이용약관을 확인하였고 이에 동의합니다.
    </label>

    <div class="title bolder my-3">개인정보의 제공(필수)</div>
    <div v-html="$linebreak(agreement4)" class="border" style="font-size:15px; height:320px; overflow-x:hidden; overflow-y:auto;"></div>
    <label class="my-2">
      <input type="checkbox"  v-model="agreements[3]">
      본인은 이용약관을 확인하였고 이에 동의합니다.
    </label>
    <div>
      <label class="my-2 bolder">
        <input type="checkbox" v-model="allAgreement">
          전체 약관에 동의합니다.
      </label>
    </div>
    <div class="mt-3 mb-5 text-center">
      <mdb-btn icon="check" @click="$emit('next')" :disabled="!isOk">확인</mdb-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { agreement1, agreement2, agreement3, agreement4 } from './agreements.js'
export default {
  name: 'Step01',
  components: { },
  data: () => ({
    user: {},
    agreement1: agreement1,
    agreement2: agreement2,
    agreement3: agreement3,
    agreement4: agreement4,
    agreements: [false, false, false, false],
    allAgreement: false
  }),
  computed: mapState({
    isOk () {
      return this.agreements[0] && this.agreements[1] && this.agreements[2] && this.agreements[3]
    }
  }),
  methods: {
  },
  watch: {
    allAgreement () {
      if (this.allAgreement) {
        this.agreements = [true, true, true, true]
      } else {
        this.agreements = [false, false, false, false]
      }
    }
  }
}
</script>
